module.exports = __webpack_public_path__ + "img/guowei.9a5c5f67.jpg";